import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterBy',
    standalone: true
})
export class FilterByPipe implements PipeTransform {

 
  transform(items: any[], filterBy: string, fields: string[]): any[] {
    if (!items) return [];
    if (!filterBy||filterBy=='all') return items;

    // searchText = searchText.toLowerCase();
    return items.filter(item => {
      return fields.some(field => {
        return item[field].toLowerCase()==filterBy
      });
    });
  }
}
